import axios from 'axios';
import { Endpoint } from 'types/url';
import { buildSearchParams } from 'utils/url';
import { BaseHttpClient } from '../BaseHttpClient';
import { injectCommonInterceptors } from '../interceptors';
import {
  GetSkillsListResponse,
  GetSkillResponse,
  GetSkillsParams,
  GetSkillInsightsResponse,
  UpdateSkillRequest,
} from './api.schema';
import { BASE_URL } from './consts';

const axiosSkillsInstance = axios.create({
  baseURL: BASE_URL,
});

injectCommonInterceptors(axiosSkillsInstance);

export class SkillsClient extends BaseHttpClient {
  constructor() {
    super(axiosSkillsInstance);
  }

  static override instance = new SkillsClient();

  static async getSkills(params?: GetSkillsParams) {
    const hasScopeFilter = Boolean(params?.scopes?.length);
    const searchParams = buildSearchParams({
      page: params?.page,
      pageSize: params?.pageSize,
      repoScope: params?.repoScope,
      nameContains: params?.nameContains,
      isRelevant: params?.isRelevant,
      state: params?.state,
      sort: params?.sort,
      sortOrder: params?.sortOrder,
      scopeMatch:
        params?.scopeMatch ?? (hasScopeFilter ? 'descendant' : undefined),
      include: params?.include,
    });

    params?.scopes?.forEach((s) => searchParams.append('scopes', s));

    return await SkillsClient.get<GetSkillsListResponse>(
      '/skills' as Endpoint,
      { params: searchParams },
    );
  }

  static async getSkill(skillId: number, include?: string) {
    return await SkillsClient.get<GetSkillResponse>(
      `/skills/${skillId}` as Endpoint,
      include ? { params: { include } } : undefined,
    );
  }

  static async updateSkill(skillId: number, payload: UpdateSkillRequest) {
    return await SkillsClient.patch<GetSkillResponse>(
      `/skills/${skillId}` as Endpoint,
      payload,
    );
  }

  static async getSkillsInsights(skillId?: number) {
    const params = skillId !== undefined ? { skillId } : undefined;

    return await SkillsClient.get<GetSkillInsightsResponse>(
      '/skills-insights' as Endpoint,
      params ? { params } : undefined,
    );
  }
}
